import { useFormSubmit } from "@/hooks/useFormSubmit";
import FormFeedback from "@/components/base/FormFeedback";

const CONTACT_ENDPOINT = "https://readdy.ai/api/form/dak3pgrbcsf0ijchd4gg";

const inputClass =
  "h-11 w-full rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400";
const labelClass =
  "mb-1.5 block text-xs font-semibold uppercase tracking-wider text-foreground-600";

export default function ContactForm() {
  const { status, errorMessage, submit } = useFormSubmit(CONTACT_ENDPOINT);

  if (status === "success") {
    return (
      <FormFeedback
        status="success"
        title="Message sent"
        message="Thanks for reaching out! Our team typically replies within one working day."
      />
    );
  }

  return (
    <form id="contact-form" data-readdy-form onSubmit={submit} className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className={labelClass} htmlFor="contact-name">
            Your name *
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            autoComplete="name"
            placeholder="e.g. Ayesha Rahman"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass} htmlFor="contact-email">
            Email *
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            className={inputClass}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className={labelClass} htmlFor="contact-phone">
            Phone
          </label>
          <input
            id="contact-phone"
            name="phone"
            type="tel"
            autoComplete="tel"
            placeholder="+91 98450 00000"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass} htmlFor="contact-subject">
            Subject *
          </label>
          <input
            id="contact-subject"
            name="subject"
            type="text"
            required
            placeholder="What is this about?"
            className={inputClass}
          />
        </div>
      </div>

      <div>
        <label className={labelClass} htmlFor="contact-message">
          Message *
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="Tell us how we can help — listing support, advertising, partnerships or feedback..."
          className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
        />
        <p className="mt-1 text-xs text-foreground-500">Maximum 500 characters.</p>
      </div>

      {/* Reserved anti-spam field — kept out of view and never required. */}
      <input
        type="text"
        name="contact_alt"
        className="field-guard-offscreen"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {status === "error" ? (
        <FormFeedback status="error" title="Could not send your message" message={errorMessage} />
      ) : null}

      <button
        type="submit"
        disabled={status === "submitting"}
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={status === "submitting" ? "ri-loader-4-line animate-spin text-base" : "ri-send-plane-line text-base"} />
        </span>
        {status === "submitting" ? "Sending..." : "Send message"}
      </button>
    </form>
  );
}